import {useMutation} from '@tanstack/react-query'
import api from 'src/services/api'

type Props = {
  cameraIds: Array<number>
}

export default function useGetCameraWarnings() {
  const mutation = useMutation({
    mutationFn: async ({cameraIds}: Props) => {
      return (await api.camera.getCameraWarnings(cameraIds)).data.data
    },
  })

  return mutation
}
